import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import { IconButton } from "@material-ui/core";
import Icon from "@material-ui/core/Icon";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Menu from "@material-ui/core/Menu";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import PhotoAlbumIcon from "@material-ui/icons/PhotoAlbum";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
// import Button from "@material-ui/core/Button";
import { getCSRFToken } from '../../common/Csrf'
import AppContainer from "../../common/AppContainer";
import { createSelector } from "../../common/orm";
import WarningDialog from "../../common/WarningDialog";
import { Page } from "../models";
import ViewRecordTable from "../table/ViewRecordTable";
// import PageAnalytics from "../advancedSearch/PageAnalytics";
import FormUpload from "../../common/FormUpload";

import ReactSelectAsync from "../../common/ReactSelectAsync";
import { Form } from "react-form";
import Box from "@material-ui/core/Box";
import HelpLabel from "../../common/HelpLabel";


const styles = (theme) => ({
    iconbutton: {
        margin: "10px 15px 0px 15px",
    },
    italics: {
        fontStyle: "italic",
    },
    floatLeft: {
        float: "left",
    },
    floatRight: {
        float: "right",
    },
    flex: {
        flex: 1,
    },

    listItem: {
        borderBottom: "1px solid #262626",
    },
    hideSmall: {
        [theme.breakpoints.down("sm")]: {
            display: "none",
        },
    },
    hideLarge: {
        [theme.breakpoints.up("md")]: {
            display: "none",
        },
    },
    list: {
        "& ul": {
            padding: 0,
        },
    },
    topListItem: {
        borderBottom: "1px solid #262626",
        backgroundColor: "#eee",
        cursor: "default",
        textAlign: "center",
    },
});

// Get the specific page objects from the page model--these are AKA props
// Ex: the URL is http://localhost:3000/#/page/49 we would get page object #49
const getPage = Page.selectByUrlId();

//get permissions
// const getPermission = createSelector(
//     (state, ownProps) => parseInt(ownProps.match.params["id"]), //input selector which matches ownProps page :id in route i.e index.js ("return id" will be injected into "pageID" in the result function args)
//     (session, pageID) => {
//         return session.Permission.filter((p) => p.page === pageID).toRefArray();
//     } //toRefArray returns a plain JavaScript object which are references to the DB
// );

const getUserPermission = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["id"]),
    (state) => state.auth?.user?.id || null,
    (session, pageID, userID) => {
        if (!userID || isNaN(pageID)) return null;
        const q = session.Permission.filter(p => p.page === pageID && p.user === userID);
        const arr = q.toRefArray();
        return arr.length ? arr[0] : null;
    }
);


const getSection = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["id"]), //input selector which matches ownProps page :id in route i.e index.js ("return id" will be injected into "pageID" in the result function args)
    (state, ownProps) => parseInt(ownProps.match.params["pageId"]),
    (session, id, pageId) => {
        if (isNaN(id)) {
            return session.Section.filter((sect) => sect.page === pageId).toRefArray();
        } else {
            return session.Section.filter((sect) => sect.page === id).toRefArray();
        }
    }
);

//get the sectionID from the URL
const getSectionId = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["sectionId"]), //input selector which matches ownProps page :id in route i.e index.js ("return id" will be injected into "pageID" in the result function args)
    (session, sectionID) => {
        return sectionID;
    }
);

class AllRecordsTableContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogOpen: false,
            open: false,
            helpMenu: null,
            smallAnchor: null,
            exportModule: false,
            exportModuleAcknowledgement: false,
            fieldToSearch: null,
            openFieldSettings: false,
        };
    }

    componentDidUpdate(prevProps) {
        const { quicksearchfields } = this.props;
        const { fieldToSearch } = this.state;
        if (quicksearchfields && quicksearchfields.length > 0 && fieldToSearch == null) {
            this.setState({ fieldToSearch: quicksearchfields[0].field_id });
        }
    }

    closeDialog = () => {
        this.setState({ dialogOpen: false });
    };

    handleHelpMenu = (event) => {
        this.setState({ helpMenu: event.currentTarget });
    };

    handleHelpMenuClose = () => {
        this.setState({ helpMenu: null });
    };
    handleSmallMenu = (event) => {
        this.setState({ smallAnchor: event.currentTarget });
    };

    handleSmallMenuClose = () => {
        this.setState({ smallAnchor: null });
    };

    errorValidator = () => ({});

    defaultUserSelectedFields = () => {
        const { quicksearchfields } = this.props;
        return (quicksearchfields || []).map((fi) => ({
            label: fi.field_name,
            value: fi.field_id,
            id: fi.id,
            contactfield: !!fi.contactfield,
            identification: fi.identification,
        }));
    };

    saveFields = (field) => {
        const { ormQuickSearchFieldCreate, ormQuickSearchFieldDelete, quicksearchfields, page } = this.props;
        (quicksearchfields || []).forEach((f) => {
            const stillSelected = (field.column || []).find((c) => f.field_id === c.value);
            if (!stillSelected) ormQuickSearchFieldDelete(f.id);
        });
        (field.column || []).forEach((c) => {
            const already = (quicksearchfields || []).some((f) => f.field_id === c.value);
            if (!already) {
                if (c.value === "All Columns" || c.value === -1) {
                    ormQuickSearchFieldCreate({ page_id: page.id, field_name: "All Columns", contactfield: false });
                } else {
                    ormQuickSearchFieldCreate({
                        page_id: page.id,
                        field_id: c.value,
                        field_name: c.label,
                        contactfield: !!c.contactfield,
                    });
                }
            }
        });
        this.setState({ openFieldSettings: false });
    };

    ACCESS_KEYS = [
        "fullaccess",
        "fullaccess_no_parent_delete",
        "fullaccess_no_delete",
        "readonly",
        "readonlyexternal",
        "noaccess",
    ];

    getAccessValueFromPerm = (perm) => {
        if (!perm) return ""; // default fallback if no row yet
        for (const k of this.ACCESS_KEYS) if (perm[k]) return k;
        return "";
    };

    getDeleteRights = (access) => {
        switch (access) {
            case "fullaccess":
                return { canDeletePrimary: true, canDeleteRelated: true };
            case "fullaccess_no_parent_delete":
                return { canDeletePrimary: false, canDeleteRelated: true };
            case "fullaccess_no_delete":
            case "readonly":
            case "readonlyexternal":
            case "noaccess":
            default:
                return { canDeletePrimary: false, canDeleteRelated: false };
        }
    };

    render() {

        const { open, helpMenu, smallAnchor, exportModule, exportModuleAcknowledgement } = this.state;
        const { classes, page, removeTitle, section, actSection, authState, formm, permission } = this.props;
        const userHelpOpen = Boolean(helpMenu);
        const smallMenuOpen = Boolean(smallAnchor);
        //get section name for header
        var sectionName = section.find((s) => {
            if (s.id === actSection) {
                return s;
            }
            return null;
        });

        // if (authState.user) {
        //     var readOnly;
        //     var perm = permission.find((p) => {
        //         if (p.user === authState.user.id) {
        //             return p;
        //         }
        //         return null;
        //     });
        //     if (perm) readOnly = perm.readonly || perm.readonlyexternal ? true : false;
        //     if (readOnly === undefined) readOnly = false;
        // }

        const perm = this.props.userPermission;
        const access = this.getAccessValueFromPerm(perm);
        const { canDeletePrimary, canDeleteRelated } = this.getDeleteRights(access);
        const readOnly = ["readonly", "readonlyexternal", "noaccess"].includes(access);


        // console.log("User Access Level: ", access);
        // console.log("Section props: ", sectionName);


        const userSelectedFields = [];
        const regFields = [];
        const contactQuick = [];
        (this.props.quicksearchfields || []).forEach((fi) => {
            const opt = {
                label: fi.field_name,
                value: fi.field_id,
                id: fi.id,
                contactfield: !!fi.contactfield,
                identification: fi.identification,
            };
            (fi.contactfield ? contactQuick : regFields).push(opt);
        });
        const parentSection = section.find((s) => s.parent === true);
        const parentName = parentSection ? parentSection.name : "";
        userSelectedFields.push({ label: " (Section " + parentName + ")", options: regFields });
        if (contactQuick.length) userSelectedFields.push({ label: "Contact Fields", options: contactQuick });

        // Build dialog options = all parent form fields (+ contact fields)
        const { pagefields, contact_fields } = this.props;
        let fields = [];
        (pagefields || []).forEach((p) => {
            p.form.forEach((f) => {
                const opts = [];
                opts.push({ label: "All Columns", value: -1, contactfield: false, identification: false });
                if (page?.id === 666 || page?.id === 708) {
                    opts.push({ label: "Parcel ID", value: -2, contactfield: false, identification: false });
                }
                f.groups.forEach((gf) => {
                    gf.fields.forEach((fi) => {
                        if (!gf.repeatable && fi.type !== "Date") {
                            opts.push({
                                label: fi.name,
                                value: fi.id,
                                id: fi.id,
                                contactfield: false,
                                identification: fi.identification,
                            });
                        }
                    });
                });
                fields.push({ label: `${f.name} (Section ${f.name})`, options: opts });
            });
        });
        if (contact_fields && contact_fields.length) {
            const cOpts = contact_fields.map((cf) => ({
                label: cf.field_name,
                value: cf.id,
                id: cf.id,
                contactfield: true,
            }));
            fields.push({ label: "Contact Fields", options: cOpts });
        }

        //////////PRINT TABLE FOR ALL RECORDS OF PAGE REMOVE "TITLE" PASSED IN FROM 'EXPANSIONPANELFORMRECORD'/////////////////////////////////////
        if (!removeTitle) {
            return (
                <AppContainer authenticated>
                    <Grid container spacing={0} style={{ height: "calc(100% - 20px)" }}>
                        <Box
                            sx={{
                                width: '100%',
                                mt: '12px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >

                            <Box
                                sx={{
                                    flex: '1 1 50%',
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    minWidth: '50%',
                                    zIndex: 1000,
                                }}
                            >
                                <Form
                                    validateOnSubmit={false}
                                    style={{
                                        zIndex: 1000,
                                        position: 'relative',
                                    }}
                                >
                                    {() => (
                                        <form
                                            style={{
                                                width: '100%',
                                                zIndex: 1000,
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: '100%',
                                                    zIndex: 1000,
                                                }}
                                            >
                                                <ReactSelectAsync
                                                    field={22}
                                                    page={this.props.page.id}
                                                    quick_search_field="All Columns"
                                                    placeholder="Search for Primary Records within this Module"
                                                    // label={
                                                    //     <HelpLabel
                                                    //         inputLabel="Search Records"
                                                    //         helpText={`Seaching of record section fields are only allowed on 'primary' form fields. 

                                                    // Instructions: 
                                                    // Type the requested search parameters into the window, after typing has stopped the quick search tool will return the database results that contain those characters.`}
                                                    //     />
                                                    // }
                                                    eventHandle={(searchvalue) => {
                                                        if (searchvalue !== "") {
                                                            this.props.history.push(
                                                                "/page/" +
                                                                searchvalue.pageid +
                                                                "/parentrecord/" +
                                                                searchvalue.parentrecord +
                                                                "/section/" +
                                                                searchvalue.section +
                                                                "/recordsection/" +
                                                                searchvalue.recordsection +
                                                                "/form"
                                                            );
                                                        }
                                                    }}
                                                />

                                            </Box>
                                        </form>
                                    )}
                                </Form>
                                <Box
                                    sx={{
                                        marginTop: '18px',
                                        marginLeft: '10px',
                                    }}
                                >
                                    <HelpLabel
                                        helpText={`The search tool only searches primary table column form fields.`}
                                    />
                                </Box>
                            </Box>

                            <Box
                                sx={{
                                    flex: '0 0 50%',
                                    display: 'flex',
                                    justifyContent: 'flex-end'
                                }}
                            >
                                {page.id && sectionName && (
                                    <Tooltip className={classes.hideSmall} title={`Dashboard`}>
                                        <IconButton className={classes.iconbutton} component={Link} to={"/dashboard/" + page.id}>
                                            <Icon>timeline</Icon>
                                        </IconButton>
                                    </Tooltip>
                                )}
                                <Tooltip className={classes.hideSmall} title="Import / Export">
                                    <IconButton className={classes.iconbutton} onClick={this.handleHelpMenu}>
                                        <Icon>import_export</Icon>
                                    </IconButton>
                                </Tooltip>
                                {page.id && sectionName && sectionName.has_geometry && (
                                    <Tooltip className={classes.hideSmall} title={`${page.name} Map`}>
                                        <IconButton
                                            className={classes.iconbutton}
                                            component={Link}
                                            to={"/map/" + page.id + "/section/" + sectionName.id + "/advancedsearch/" + 1}>
                                            <Icon>map</Icon>
                                        </IconButton>
                                    </Tooltip>
                                )}
                                {sectionName && (
                                    <Tooltip className={classes.hideSmall} title={`Search`}>
                                        <IconButton className={classes.iconbutton} component={Link} to={"/page/" + page.id + "/advancedsearch"}>
                                            <Icon>search</Icon>
                                        </IconButton>
                                    </Tooltip>
                                )}
                                {authState.user && authState.user.is_city_admin === true && (
                                    <Tooltip className={classes.hideSmall} title="Module Configuration">
                                        <IconButton
                                            disabled={readOnly}
                                            className={classes.iconbutton}
                                            component={Link}
                                            to={"/page/" + page.id + "/config"} //route to page config
                                        >
                                            <Icon>settings</Icon>
                                        </IconButton>
                                    </Tooltip>
                                )}

                                <Menu
                                    id="importexport"
                                    anchorEl={helpMenu}
                                    classes={{
                                        paper: classes.list,
                                    }}
                                    anchorOrigin={{
                                        vertical: "top",
                                        horizontal: "right",
                                    }}
                                    transformOrigin={{
                                        vertical: "top",
                                        horizontal: "right",
                                    }}
                                    open={userHelpOpen}
                                    onClose={this.handleHelpMenuClose}
                                >
                                    <ListItem button className={classes.topListItem}>
                                        <ListItemText
                                            primary={<Typography variant="h6">Import / Export</Typography>}
                                            classes={{
                                                root: classes.topListText,
                                                primary: classes.topListText,
                                            }}
                                        />
                                    </ListItem>
                                    <table style={{ width: "100%" }}>
                                        {authState.user && authState.user.is_city_admin === true && (
                                            <tr>
                                                <td>
                                                    <ListItem
                                                        button
                                                        className={classes.listItem}
                                                        onClick={() => {
                                                            return (
                                                                this.setState({ open: true }), //route to page config
                                                                this.handleHelpMenuClose()
                                                            );
                                                        }}>
                                                        <Icon style={{ paddingRight: 7 }}>cloud_upload </Icon>
                                                        <ListItemText primary={`Import Records`} />
                                                    </ListItem>
                                                </td>
                                            </tr>
                                        )}
                                        <tr>
                                            <td>
                                                <ListItem
                                                    button
                                                    className={classes.listItem}
                                                    onClick={() => {
                                                        if (!exportModule) {
                                                            this.setState({ exportModuleAcknowledgement: true });
                                                            this.handleHelpMenuClose();

                                                        }
                                                    }}>
                                                    <CloudDownloadIcon style={{ paddingRight: 7 }} />
                                                    <ListItemText primary={`Export Records`} />
                                                </ListItem>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <ListItem
                                                    button
                                                    className={classes.listItem}
                                                    onClick={() => {
                                                        return (
                                                            window.open("/attachments/page/" + page.id),
                                                            this.handleHelpMenuClose()
                                                        );
                                                    }}>
                                                    <PhotoAlbumIcon style={{ paddingRight: 7 }} />
                                                    <ListItemText primary={`Export Attachments`} />
                                                </ListItem>
                                            </td>
                                        </tr>
                                    </table>
                                </Menu>

                                <Menu
                                    id="menu-small"
                                    anchorEl={smallAnchor}
                                    classes={{
                                        paper: classes.list,
                                    }}
                                    anchorOrigin={{
                                        vertical: "top",
                                        horizontal: "right",
                                    }}
                                    transformOrigin={{
                                        vertical: "top",
                                        horizontal: "right",
                                    }}
                                    open={smallMenuOpen}
                                    onClose={this.handleSmallMenuClose}>
                                    <ListItem button className={classes.topListItem}>
                                        <ListItemText
                                            primary={<Typography variant="h6">Page Menu</Typography>}
                                            classes={{
                                                root: classes.topListText,
                                                primary: classes.topListText,
                                            }}
                                        />
                                    </ListItem>
                                    {sectionName && sectionName.has_geometry && (
                                        <ListItem
                                            button
                                            component={Link}
                                            to={"/map/" + page.id + "/section/" + sectionName.id + "/advancedsearch/" + 1}
                                            className={classes.listItem}>
                                            <ListItemIcon>
                                                <Icon>map</Icon>
                                            </ListItemIcon>
                                            <ListItemText primary={`All ${sectionName.name} Geometries`} />
                                        </ListItem>
                                    )}
                                    {sectionName && (
                                        <ListItem
                                            button
                                            component={Link}
                                            to={"/page/" + page.id + "/advancedsearch"}
                                            className={classes.listItem}>
                                            <ListItemIcon>
                                                <Icon>search</Icon>
                                            </ListItemIcon>
                                            <ListItemText primary={`All ${sectionName.name} Saved Searches`} />
                                        </ListItem>
                                    )}
                                    <ListItem button onClick={this.handleHelpMenu} className={classes.listItem}>
                                        <ListItemIcon>
                                            <Icon>import_export</Icon>
                                        </ListItemIcon>
                                        <ListItemText primary="Import / Export" />
                                    </ListItem>{" "}
                                    {authState.user && authState.user.is_city_admin === true && (
                                        <ListItem button component={Link} to={"/page/" + page.id + "/config"} className={classes.listItem}>
                                            <ListItemIcon>
                                                <Icon>settings</Icon>
                                            </ListItemIcon>
                                            <ListItemText primary="Module Configuration" />
                                        </ListItem>
                                    )}
                                </Menu>
                            </Box>
                        </Box>


                        <Grid item xs={12}>
                            <Grid container spacing={0}>
                                <Grid className={classes.hideSmall} item xs={6}>
                                    {sectionName && <Typography variant="h5">{page.name + " - " + sectionName.name}</Typography>}
                                    <Typography variant="body1" className={classes.italics}>
                                        Use the table below, the filter tool or the map to identify and select an existing record or create a new
                                        record.
                                    </Typography>
                                </Grid>


                                <Grid className={classes.hideLarge} item xs={10}>
                                    {sectionName && (
                                        <Typography variant="h5" style={{ paddingTop: 17 }}>
                                            {page.name + " - " + sectionName.name}
                                        </Typography>
                                    )}
                                    <Typography variant="body1" className={classes.italics}>
                                        Use the table below, the filter tool or the map to identify and select an existing record or create a new
                                        record.
                                    </Typography>
                                </Grid>
                                <Grid className={classes.hideLarge} style={{ textAlign: "right", paddingTop: 17 }} item xs={2}>
                                    <Tooltip title="Module Menu" placement="bottom-start" enterDelay={300}>
                                        <IconButton className={classes.headerButton} onClick={this.handleSmallMenu}>
                                            <MoreVertIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* <Grid item xs={12}>
                            <PageAnalytics pageID={page.id} />
                        </Grid> */}
                        <Grid item xs={12}>
                            {exportModuleAcknowledgement && (
                                <WarningDialog
                                    confirmAction={() => {
                                        this.setState({ exportModule: true, exportModuleAcknowledgement: false });
                                        try {
                                            fetch(`/exportpage/page/${page.id}`, {
                                                method: "GET",
                                                headers: {
                                                    "X-CSRFToken": getCSRFToken(),
                                                    "Content-Disposition": "attachment",
                                                },
                                            }).then((e) => {
                                                if (e.status === 403) {
                                                    return;
                                                }
                                                return e.blob().then((blob) => {
                                                    var url = window.URL.createObjectURL(blob);
                                                    var a = document.createElement("a");
                                                    a.href = url;
                                                    a.download = `Records Export - ${page.name}.xlsx`;
                                                    document.body.appendChild(a);
                                                    a.click();
                                                    a.remove();

                                                    this.setState({ exportModule: false });
                                                });
                                            });
                                        } catch {
                                            this.setState({ exportModule: false });
                                        }

                                    }}
                                    cancelAction={() => this.setState({ exportModuleAcknowledgement: false })}
                                    open={exportModuleAcknowledgement}
                                    confirmText="Start Export"
                                    cancelText="Export Later"
                                    title={`Export ${page.name} Module?`}
                                    text={`Exporting modules may take a while depending on the total amount of records. Please wait and dont re-export or refresh the page for up to an hour`}
                                />
                            )}
                            {exportModule && (
                                <Dialog open={exportModule} style={{ minHeight: 250 }}>
                                    <DialogContent style={{ minWidth: 400 }}>
                                        <DialogContentText>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} style={{ textAlign: "center" }}>
                                                    <CircularProgress size={90} className={classes.progress} />
                                                    <Typography variant="h6" style={{ textAlign: "center" }}>
                                                        Exporting {page.name}. This may take a while if there were a lot of records.
                                                        Please wait...
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </DialogContentText>
                                    </DialogContent>
                                </Dialog>
                            )}
                        </Grid>


                        <Grid item xs={12} style={{ height: "100%" }}>
                            <ViewRecordTable
                                pageID={page.id}
                                showParentTable={true}
                                canDeletePrimary={canDeletePrimary}
                                canDeleteRelated={canDeleteRelated}
                            />
                        </Grid>


                        {sectionName && (
                            <FormUpload
                                page={page}
                                section={sectionName.id}
                                authState={authState}
                                formm={formm}
                                classes={classes}
                                open={open}
                                returnDialog={() => {
                                    this.setState({ open: false });
                                }}
                            />
                        )}
                    </Grid>
                </AppContainer>
            );
        }
    }
}
AllRecordsTableContainer.displayName = "AllRecordsTableContainer";

AllRecordsTableContainer = connect(
    (state, ownProps) => ({
        section: getSection(state, ownProps),
        actSection: getSectionId(state, ownProps),
        page: getPage(state, ownProps),

        // Testing for functionaility update
        authState: state.auth, //component wide state prop "authState" gets derived info from database
        // permission: getPermission(state, ownProps),
        userPermission: getUserPermission(state, ownProps),
    }),
    null
)(AllRecordsTableContainer);

export default withStyles(styles)(withRouter(AllRecordsTableContainer));
